var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.conversationClass},[(_vm.currentChat.id)?_c('messages-view',{attrs:{"inbox-id":_vm.inboxId,"is-contact-panel-open":_vm.isContactPanelOpen},on:{"contact-panel-toggle":_vm.onToggleContactPanel}}):_c('empty-state')],1)}
var staticRenderFns = []

export { render, staticRenderFns }